export default __webpack_public_path__ + "images/date-icon.6fce2f01db52c3f1574079dbd36648bd.svg";